export default __webpack_public_path__ + "1.17.19/static/media/libreLinkUp.07cb949d.svg";